import React from 'react';
import { motion } from 'framer-motion';
import { Leaf, Flower2, Sprout, Droplets } from 'lucide-react';
import { InlineCTA } from './InlineCTA';
export function ProductSection() {
  const ingredients = [{
    icon: <Flower2 className="w-6 h-6 text-brand-green" data-id="element-104" />,
    name: 'Mariendistel',
    desc: 'Legt sich wie ein schützender Film über die Magenschleimhaut und beruhigt gereizte Stellen sanft.'
  }, {
    icon: <Sprout className="w-6 h-6 text-brand-green" data-id="element-105" />,
    name: 'Topinambur & Inulin',
    desc: 'Wertvolle Präbiotika, die die guten Bakterien im Darm füttern und so für eine gesunde Flora sorgen.'
  }, {
    icon: <Leaf className="w-6 h-6 text-brand-green" data-id="element-106" />,
    name: 'Artischocke',
    desc: 'Fördert die natürliche Gallenproduktion und hilft dem Hund, Fette besser zu verdauen.'
  }, {
    icon: <Droplets className="w-6 h-6 text-brand-green" data-id="element-107" />,
    name: 'Johannisbrotmehl',
    desc: 'Hilft dabei, den Magen-pH-Wert auf natürliche Weise zu regulieren und überschüssige Säure zu binden.'
  }];
  return <section className="bg-brand-lightGreen py-16 px-6" data-id="element-108">
      <div className="max-w-3xl mx-auto" data-id="element-109">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-110">
          <h2 className="text-3xl font-bold text-brand-brown mb-4" data-id="element-111">
            Was steckt dahinter?
          </h2>
          <p className="text-lg text-stone-600 font-serif max-w-2xl mx-auto" data-id="element-112">
            Ich wollte genau wissen, warum dieses Pulver so gut hilft. Das
            Geheimnis liegt in der Kombination aus 100% natürlichen Zutaten –
            ganz ohne künstliche Zusätze.
          </p>
        </motion.div>

        <div className="grid sm:grid-cols-2 gap-6 mb-10" data-id="element-113">
          {ingredients.map((item, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.1
        }} className="bg-white p-6 rounded-xl shadow-sm border border-stone-100" data-id="element-114">
              <div className="w-12 h-12 bg-brand-lightGreen rounded-full flex items-center justify-center mb-4" data-id="element-115">
                {item.icon}
              </div>
              <h3 className="font-sans font-bold text-xl text-brand-brown mb-2" data-id="element-116">
                {item.name}
              </h3>
              <p className="text-stone-600 font-serif" data-id="element-117">{item.desc}</p>
            </motion.div>)}
        </div>

        <InlineCTA label="Jetzt für meinen Hund bestellen" position="ingredients_cta" data-id="element-118" />
      </div>
    </section>;
}